export const imageBreakpoints: Record<number, number | number[]> = {
	1920: 1900,
	1680: 1600,
	1600: 1500,
	1536: 1500,
	1440: 1400,
	1366: 1300,
	1280: 1200,
	428: [400, 500, 600],
	414: [400, 500, 600],
	412: [400, 500, 600],
	393: [400, 500, 600],
	390: [400, 500, 600],
	385: [350, 400, 500],
	384: [350, 400, 500],
	375: [350, 400, 500],
	360: [350, 400, 500],
	320: [300, 350, 400],
};
